import { useState } from 'react';
import { useOutletContext } from 'react-router';
import { useReportTimeline } from '../api/reports';
import { LastUpdated } from '../components/LastUpdated';
import { Money } from '../components/Money';
import type { SalesContext } from './Sales';

export function SalesTimeline() {
  const { eventId, range } = useOutletContext<SalesContext>();
  const [interval, setInterval] = useState<'hour' | 'day'>('day');
  const { data, isLoading, isError, dataUpdatedAt } = useReportTimeline(eventId, range, interval);

  if (isLoading) return <div style={{ color: 'var(--fg-3)' }}>Loading…</div>;
  if (isError || !data) return <div className="form-error">Couldn't load timeline.</div>;

  const max = data.rows.reduce((m, r) => Math.max(m, r.grossCents), 0);

  return (
    <div style={{ display: 'grid', gap: 12 }}>
      <div style={{ display: 'inline-flex', gap: 8 }}>
        <button
          type="button"
          className="filter-chip"
          data-active={interval === 'day'}
          onClick={() => setInterval('day')}
        >
          By day
        </button>
        <button
          type="button"
          className="filter-chip"
          data-active={interval === 'hour'}
          onClick={() => setInterval('hour')}
        >
          By hour
        </button>
      </div>
      <div className="card" style={{ overflow: 'hidden' }}>
        <table className="tbl">
          <thead>
            <tr>
              <th>{interval === 'day' ? 'Day' : 'Hour'}</th>
              <th className="num">Sales</th>
              <th className="num">Gross</th>
              <th>Distribution</th>
            </tr>
          </thead>
          <tbody>
            {data.rows.map((row) => {
              const pct = max > 0 ? (row.grossCents / max) * 100 : 0;
              const date = new Date(row.bucketStart);
              const label =
                interval === 'day'
                  ? date.toLocaleDateString(undefined, {
                      month: 'short',
                      day: 'numeric',
                    })
                  : date.toLocaleString(undefined, {
                      month: 'short',
                      day: 'numeric',
                      hour: 'numeric',
                    });
              return (
                <tr key={row.bucketStart}>
                  <td>{label}</td>
                  <td className="num">{row.txnCount}</td>
                  <td className="num">
                    <Money value={row.grossCents / 100} />
                  </td>
                  <td style={{ width: '40%' }}>
                    <div
                      style={{
                        height: 8,
                        background: 'var(--bg-surface-2)',
                        borderRadius: 4,
                        overflow: 'hidden',
                      }}
                    >
                      <div
                        style={{
                          width: `${pct}%`,
                          height: '100%',
                          background: 'var(--oeg-purple)',
                        }}
                      />
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <LastUpdated dataUpdatedAt={dataUpdatedAt} />
    </div>
  );
}
